// Reload the current page after a successful Validate & Lock so that the
// view-mode banner picks up the new "Validated" status. We drop ?edit=true
// from the query string so that the canonical isReadOnly check
//   (status === "Validated" && !isEditMode)
// evaluates to true on the next render.
export const reloadAfterValidate = (delayMs = 800) => {
  const params = new URLSearchParams(window.location.search);
  params.delete("edit");
  const next = `${window.location.pathname}?${params.toString()}`;
  setTimeout(() => {
    window.location.href = next;
  }, delayMs);
};
